// Instance
import AuthAPI from '@/app/apis/auth/auth-api.js';

// Endpoints
import { AUTH, AUTH_ENDPOINTS } from '@/app/apis/auth/_connection/auth-connection-api.js';

class AuthSetPasswordAPI extends AuthAPI {
    /**
     * @param {*} userDetails - Contains email and Resume link
     */
    async postAuthSetPass(userDetails) {
        return AUTH.post(AUTH_ENDPOINTS.POST_SET_PASSWORD, userDetails);
    }
}
	
export default new AuthSetPasswordAPI();